import axios from 'axios'
import getCompanies from '../modules/getCompanies'

/**
 * Gets all companies from backend API.
 */
export default function getAllCompanies ({ commit, state }) {
  axios.get(`${process.env.VUE_APP_API_URL}api/companies/all`, {
    headers: {
      'x-access-token': localStorage.getItem('user-token')
    }
  })
    .then(function (response) {
      commit('updateCompanies', getCompanies(response.data.data))
    })
    .catch(function (error) {
      console.log(error)
    })
}
